import { render, staticRenderFns } from "./SingleReport.vue?vue&type=template&id=0faa0a90&scoped=true&"
import script from "./SingleReport.vue?vue&type=script&lang=ts&"
export * from "./SingleReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faa0a90",
  null
  
)

export default component.exports